var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1333_7289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 12C2.69 12 0 9.31 0 6C0 2.69 2.69 0 6 0C9.31 0 12 2.69 12 6C12 9.31 9.31 12 6 12ZM6 1C3.24 1 1 3.24 1 6C1 8.76 3.24 11 6 11C8.76 11 11 8.76 11 6C11 3.24 8.76 1 6 1Z",
    fill: "#7C8594"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6 9.5C5.72 9.5 5.5 9.28 5.5 9V4.75C5.5 4.47 5.72 4.25 6 4.25C6.28 4.25 6.5 4.47 6.5 4.75V9C6.5 9.28 6.28 9.5 6 9.5Z",
    fill: "#7C8594"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6 3.50031C5.87 3.50031 5.74 3.45031 5.65 3.35031C5.55 3.26031 5.5 3.13031 5.5 3.00031C5.5 2.87031 5.55 2.74031 5.65 2.65031C5.83 2.46031 6.17 2.46031 6.35 2.65031C6.45 2.74031 6.5 2.87031 6.5 3.00031C6.5 3.13031 6.45 3.26031 6.35 3.35031C6.26 3.45031 6.13 3.50031 6 3.50031Z",
    fill: "#7C8594"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1333_7289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/aboutUs.601e26ef54da0d9fc54b2ab35d6f42f3.svg";
export { ForwardRef as ReactComponent };